import {
  Typography,
  Divider,
  Breadcrumbs,
  Link as MuiLink,
} from "@mui/material";
import { Link as RouterLink, useHistory } from "react-router-dom";
import { ROUTES } from "../../constants";
import { Helmet } from "react-helmet-async";
import { DynamicForm } from "../../dynamicForm/forms/DynamicForm";
import React from "react";
import { useDynamicForm } from "../../dynamicForm/hooks/useDynamicForm";
import existingWellRegistrationFormConfig, {
  PURPOSE_OF_EXEMPT_WELL_FIELDS,
} from "../../dynamicForm/formConfigs/existingWellRegistrationFormConfig";
import {
  ContentSkeleton,
  ErrorCard,
  PageContainer,
} from "../../dynamicForm/components/ui";

function validatePurposeOfWell(data) {
  const selected = PURPOSE_OF_EXEMPT_WELL_FIELDS.filter((k) => data[k]);
  if (selected.length !== 1) {
    return [
      {
        path: [selected[0] ?? PURPOSE_OF_EXEMPT_WELL_FIELDS[0]],
        message: "Select exactly one purpose type",
        type: "group",
      },
    ];
  }
  return [];
}

const IS_NEW = true;
const FORM_NDX = null;

export default function ExistingWellRegistrationPage() {
  const history = useHistory();
  const redirectPath = ROUTES.PUBLIC_FORMS;

  const handleRedirect = () => history.push(redirectPath);

  const { isFetching, error, refetchFormData, refetchLookups, ...rest } =
    useDynamicForm({
      ndx: FORM_NDX,
      isNewRecord: IS_NEW,
      config: existingWellRegistrationFormConfig,
      endpoints: { submit: `/existing-well-registration` },
      handleRedirect,
      onSuccess: () => {},
      customValidate: validatePurposeOfWell,
    });

  const anyError = error;
  const loading = isFetching;
  const retryActions = [refetchFormData, refetchLookups].filter(Boolean);

  const pageTitle = "Existing Well Registration Request";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      <Typography variant="h3" gutterBottom>
        {pageTitle}
      </Typography>

      <Breadcrumbs sx={{ mt: 4 }} aria-label="Breadcrumb">
        <MuiLink component={RouterLink} to={ROUTES.LANDING}>
          Home
        </MuiLink>
        <MuiLink component={RouterLink} to={ROUTES.PUBLIC_FORMS}>
          Forms
        </MuiLink>
        <Typography>Existing Well Registration</Typography>
      </Breadcrumbs>

      <Divider sx={{ my: 6 }} />

      <PageContainer>
        {anyError ? (
          <ErrorCard
            onRetry={() => Promise.all(retryActions.map((fn) => fn()))}
            isFetching={loading}
          />
        ) : loading ? (
          <ContentSkeleton />
        ) : (
          <DynamicForm config={existingWellRegistrationFormConfig} {...rest} />
        )}
      </PageContainer>
    </>
  );
}
